
Checkout.Payment.CreditCardWrap = function(checkout, payment) {
	ccwrap = this;

	this.$tpl = $('#payment-method-creditcard-wrap-tpl');

	this.$wrap =
	this.$container =
	this.$note =
		false;
	
	this.init = function() {

		ccwrap.$wrap = ccwrap.$tpl
			.clone(true)
			.removeAttr('id');

		ccwrap.$container = ccwrap.$wrap.find('.payment-method-creditcard-container');
		ccwrap.$note = ccwrap.$wrap.find('.payment-method-creditcard-note');

		payment.$methodContainer.append(ccwrap.$wrap);
	};

	this.remove = function() {
		ccwrap.$wrap.remove();
	};

	this.init();
};

